export const environment = {
    production: true,
    config: {
      auth: {
          "clientId": "29fccd8a-da3e-4a26-9464-07192fbc3af8",
          "authority": "https://login.microsoftonline.com/82515c95-7506-4e7e-89e0-07f99349ddcb",
          "validateAuthority": true,
          "redirectUri": "https://monitor.numia.co/auth",
          "postLogoutRedirectUri": "https://monitor.numia.co",
      },
      cache: {
          "cacheLocation": "localStorage"
      },
      resources: {
        "api": {
            "resourceUri": 'https://monitor.numia.co/api', // example "http://localhost:4013"
            "resourceScope": "api://29fccd8a-da3e-4a26-9464-07192fbc3af8/access_as_user", // here use the client id of the Web API you registered
        }
      },
      scopes: {
          "loginRequest": [
              "openid",
              "profile"
          ]
      }
    },
    backendUrl: 'https://monitor.numia.co'
  };